import React, { useState } from 'react';
import { IMenuLink } from '../Header.links';
import menuLinkClickStatsigTrack from 'src/functions/menuClickLinkStatsigTrack';
import { SideBarExpandableToggle, SideBarExpandableToggleContent, SideBarStandardLink } from './SideBarLink.styles';
import Chevron from 'src/images/2023_Q4/Chevron';

const SideBarLink = (props: IMenuLink): JSX.Element => {
  const [expandableMenuOpen, setExpandableMenuOpen] = useState(false);
  const { href, text, trackingSlug, useExpandableMenu } = props;

  const trackLinkOnCLick = () => {
    menuLinkClickStatsigTrack(trackingSlug);
    return true; // To proceed with anchor link event
  };

  const onExpandableMenuToggle = () => {
    if (!expandableMenuOpen) {
      // Track only opening the expandable menu
      trackLinkOnCLick();
    }

    setExpandableMenuOpen(!expandableMenuOpen);
  };

  const onExpandableMenuClose = () => {
    setExpandableMenuOpen(false);
  };

  if (useExpandableMenu && props.expandableMenu) {
    return (
      <SideBarExpandableToggleContent>
        <SideBarExpandableToggle onClick={onExpandableMenuToggle}>
          <span>{text}</span>
          <Chevron
            width={38}
            orientation={expandableMenuOpen ? 'up' : 'down'}
          />
        </SideBarExpandableToggle>
        <props.expandableMenu
          isOpen={expandableMenuOpen}
          onClose={onExpandableMenuClose}
        />
      </SideBarExpandableToggleContent>
    );
  }

  return (
    <SideBarStandardLink
      key={text}
      to={href}
      onClick={trackLinkOnCLick}
    >
      {text}
    </SideBarStandardLink>
  );
};

export default SideBarLink;
